import React from 'react';
import { BrowserRouter as Router, Link, Routes, Route } from 'react-router-dom';
import logo_img from '../media/logo-img.png'
import VFooter from '../components/VFooter'
import Top from './Top'
import { Card } from './ui';
const TermsAndServices = () => {
  return (
    <div className="h-[100%] ">
            <Top/>
      {/* Main Content */}
      <main className="pt-32">
        <section className="py-8 px-3 bg-[#f4ece5] text-gray-800 font-sans">
          <div className="max-w-4xl mx-auto p-8 bg-white rounded-lg shadow-md">
            <h2 className="text-3xl font-bold text-center mb-8">Terms and Services</h2>
            <div className="space-y-6">
              <p>By using the Vasstr platform, you agree to the following terms:</p>
              
              <p>
                <strong>1. Agreement to Terms:</strong> Before registering as a designer, you must review and sign the agreement provided. 
                By signing the agreement, you acknowledge that you understand and agree to these terms and any future updates.
              </p>
              
              <p>
                <strong>2. User Accounts:</strong> You are responsible for maintaining the confidentiality of your account information 
                and for all activities conducted under your account.
              </p>
              
              <p>
                <strong>3. Design Ownership:</strong> You retain full ownership of your designs. Vasstr provides a platform for you to 
                showcase and sell your creations.
              </p>
              
              <p>
                <strong>4. Commission Structure:</strong> A 3% fee will be deducted from each order once the user confirms receipt of 
                their product.
              </p>
              
              <p>
                <strong>5. Shipping Responsibilities:</strong> Currently, Vasstr does not handle shipping logistics. You are responsible 
                for packaging and delivering orders to users.
              </p>
              
              <p>
                <strong>6. Termination:</strong> Vasstr reserves the right to deactivate your account if you violate these terms, such as 
                by repeatedly uploading unwanted photos.
              </p>
              
              <p>
                <strong>7. Limitation of Liability:</strong> Vasstr is not liable for any indirect damages resulting from your use of the 
                platform.
              </p>
              
              <p>
                <strong>8. Governing Law:</strong> These terms are governed by the laws of India. Any disputes will be subject to the 
                exclusive jurisdiction of the courts in Hyderabad, Telangana.
              </p>
            </div>
          </div>
        </section>
      </main>
     <VFooter/>
    </div>
  );
};
export default TermsAndServices;